<template>
  <div>
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <v-toolbar card color="white">
                <v-toolbar-title class="indigo--text"
                  >Información de Reportería</v-toolbar-title
                >
              </v-toolbar>
              <grafica-barra-reporteria
                v-if="id == 1 || id == 3 || id == 6 || id == 7"
              ></grafica-barra-reporteria>
              <grafica-circulo v-if="id == 4 || id == 5"></grafica-circulo>
              <dia-aplicacion-sub-tab
                :tabse="'Cursos Regulares'"
                v-if="tabSelected == 'Cursos Regulares' || id == 8"
              ></dia-aplicacion-sub-tab>
              <grafica-acu v-if="id == 2"></grafica-acu>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GraficaBarraReporteria from "@/modules/configuration/reporteria/views/GraficaBarraReporteria.vue";
import GraficaCirculo from "@/modules/configuration/reporteria/views/GraficaCirculo.vue";
import DiaAplicacionSubTab from "@/modules/configuration/reporteria/views/DiaAplicacionSubTab.vue";
import GraficaAcu from "@/modules/configuration/reporteria/views/GraficaAcu.vue";

export default {
  name: "graficas-reporteria",

  components: {
    GraficaBarraReporteria,
    GraficaCirculo,
    DiaAplicacionSubTab,
    GraficaAcu,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      id: "",
    };
  },

  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proSelectedStored = this.$store.getters.proSelectedStored;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
